module.exports = __webpack_public_path__ + "img/employee-torso.590e5d5c.png";